import LazyImage from '@/components/LazyImage'
import styles from './index.module.sass'

interface Props {
  imageUrl?: string,
  message: string
}

const CouponToast = ({ imageUrl, message }: Props) => {
  return (
    <div className={styles.couponToast}>
      {
        imageUrl
          ? (
            <div className={styles.image}>
              <LazyImage
                lazy={0}
                src={imageUrl}
              />
            </div>
            )
          : null
      }
      <div className={styles.message}>{message}</div>
    </div>
  )
}

CouponToast.defaultProps = {
  imageUrl: undefined
}

export default CouponToast
